document.addEventListener('DOMContentLoaded', function () {
    var offcanvasRight = document.getElementById('offcanvasRight');
    var offcanvasBody = document.getElementById('variant-wrapper');
    var offcanvasHeader = document.querySelector('.Variant-title-drawer');
    var optionsTitle = document.querySelector('.product-variant-wrapper');
    var optionSizechart = document.querySelector('.variant-size-guide');
    var sizeguidTitle = document.querySelector('.size-guid-title');
    var Activeproduct = document.querySelector('.list-custom-swatch .active');
    var backgroundClr = document.querySelector('.selected-color-img');

    var sizeSelectedValueEl = document.querySelector('#sizeSelectedValue');
    var stickyAddToCart = document.querySelector('#sticky-add-to-cart');
    var stickyAddToCartSize = document.querySelector('#sticky-add-to-cart-size');

    var isSingleOneSize = false;
    var sizeOptions = document.querySelectorAll('.js.product-form-input.size .option-btn, .js.product-form-input.Size .option-btn, .js.product-form-input.template-size .option-btn');
    if (sizeOptions.length === 1) {
        isSingleOneSize = true;
    }

    if (sizeSelectedValueEl && !isSingleOneSize) {
        sizeSelectedValueEl.style.display = 'none';
    }
    if (stickyAddToCart && !isSingleOneSize) {
        stickyAddToCart.style.display = 'none';
    }
    if (stickyAddToCartSize && !isSingleOneSize) {
        stickyAddToCartSize.style.display = 'block';
    } else if (stickyAddToCartSize && isSingleOneSize) {
        stickyAddToCartSize.style.display = 'none';
    }

    var productSizeDiv = document.querySelector('.product-select-size');
    var isAvailable = productSizeDiv.getAttribute('data-available');

    if (isAvailable === 'true' || isSingleOneSize) {
        document.querySelector('.product-add-cart-form').style.display = 'block';
        document.querySelector('.product-add-cart-form').style.zIndex = '1';
        if (productSizeDiv) productSizeDiv.style.display = 'none';
    } else {
        document.querySelector('.product-add-cart-form').style.display = 'none';
        if (productSizeDiv) productSizeDiv.style.display = 'block';
    }

    offcanvasRight.addEventListener('show.bs.offcanvas', function (event) {
        var triggerElement = event.relatedTarget;
        var optionName = triggerElement.innerText.trim().toLowerCase();

        // If triggered by "SELECT SIZE" or "SELECT A SIZE" button/label, normalize to "size"
        if (optionName.includes('size')) {
            optionName = 'size';
        }

        var optionsContainerId = optionName + 'OptionsContainer';
        var optionsContainer = document.getElementById(optionsContainerId);

        if (optionsContainer) {
            offcanvasBody.innerHTML = optionsContainer.innerHTML;
            addOptionChangeListeners(optionName);
            addOptionClickListeners(optionName);

            // Simple: Get selected value and add checked class to matching label
            // Only apply border if sizeSelectedValue div is visible
            var selectedValueDiv = document.getElementById(optionName + 'SelectedValue');
            var isVisible = selectedValueDiv && window.getComputedStyle(selectedValueDiv).display !== 'none';

            if (isVisible) {
                var selectedValue = selectedValueDiv.textContent.trim();
                if (selectedValue) {
                    offcanvasBody.querySelectorAll('.opt-label').forEach(function (label) {
                        var labelText = label.querySelector('.opt-label-text');
                        if (labelText && labelText.textContent.trim() === selectedValue) {
                            label.classList.add('checked');
                        }
                    });
                }
            }
        }
        updateOffcanvasHeader(optionName);

        // Size chart trigger click - only add listener once
        var triggerButton = document.getElementById('variant-size-guid');
        var anchorTag = document.querySelector('.size-chart-modal');

        if (triggerButton && anchorTag && !triggerButton.hasAttribute('data-listener-added')) {
            triggerButton.setAttribute('data-listener-added', 'true');
            triggerButton.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                anchorTag.click();
            });
        }
    });


    function addOptionChangeListeners(optionName) {
        var options = offcanvasBody.querySelectorAll('.option-btn');

        options.forEach(function (option) {
            option.addEventListener('change', function () {

                // Sync main product input
                var mainInput = document.querySelector(
                    '.js.product-form-input input[name="' + option.name + '"][value="' + option.value + '"]'
                );
                if (mainInput) {
                    mainInput.checked = true;
                    mainInput.dispatchEvent(new Event('change', { bubbles: true }));
                }

                // UI checked state
                offcanvasBody.querySelectorAll('.opt-label').forEach(function (lbl) {
                    lbl.classList.remove('checked');
                });

                var label = offcanvasBody.querySelector('label[for="' + option.id + '"]');
                if (label) label.classList.add('checked');

                updateSelectedValue(optionName, option.value);

                // Close drawer
                var closeBtn = document.querySelector('.product-variant-drawer .btn-close');
                if (closeBtn) closeBtn.click();
            });
        });
    }



    function addOptionClickListeners(optionName) {
        var optionsclick = offcanvasBody.querySelectorAll('.opt-label');

        optionsclick.forEach(function (optionclick) {
            optionclick.addEventListener('click', function () {
                // Get the associated radio input
                var labelFor = optionclick.getAttribute('for');
                var radioInput = offcanvasBody.querySelector('input[type="radio"][id="' + labelFor + '"]');

                if (radioInput) {
                    // Check the radio input
                    radioInput.checked = true;

                    // Trigger change event to sync with main form and update selected value
                    radioInput.dispatchEvent(new Event('change', { bubbles: true }));

                    // Sync main product input
                    var mainInput = document.querySelector(
                        '.js.product-form-input input[name="' + radioInput.name + '"][value="' + radioInput.value + '"]'
                    );
                    if (mainInput) {
                        mainInput.checked = true;
                        mainInput.dispatchEvent(new Event('change', { bubbles: true }));
                    }

                    // Update selected value display
                    updateSelectedValue(optionName, radioInput.value);
                    renderVariantUI(optionName, radioInput);
                }

                // UI checked state
                optionsclick.forEach(function (optclick) {
                    optclick.classList.remove('checked');
                });
                optionclick.classList.add('checked');

                // Close drawer
                var triggerButtonClose = document.querySelector('.product-variant-drawer .btn-close');
                if (triggerButtonClose) {
                    triggerButtonClose.click();
                }
            });
        });
    }

    function updateSelectedValue(optionName, selectedValue) {
        var selectedValueDiv = document.getElementById(optionName + 'SelectedValue');
        if (selectedValueDiv) {
            selectedValueDiv.textContent = selectedValue;
            if (backgroundClr != null) {
                backgroundClr.style.background = selectedValue;
            }
        }
    }

    function updateOffcanvasHeader(optionName) {
        if (offcanvasHeader) {
            offcanvasHeader.textContent = 'Select ' + optionName;
            var selectedColor = document.getElementById('colorSelectedValue').textContent.trim().toLowerCase();

            var labels = document.querySelectorAll('#variant-wrapper label[data-swatch]');

            labels.forEach(function (label) {
                if (label.getAttribute('data-swatch').toLowerCase() === selectedColor) {
                    label.classList.add('checked');
                } else {
                    label.classList.remove('checked');
                }
            });

            if (optionName == 'color') {
                optionsTitle.classList.add(optionName);
                optionSizechart.classList.remove('d-block');
                optionSizechart.classList.add('d-none');
            } else {
                optionsTitle.classList.remove('color');
                if (optionSizechart) {
                    optionSizechart.classList.add('d-block');
                    optionSizechart.classList.remove('d-none');
                }
                if (Activeproduct != null) {
                    var anchorText = Activeproduct.textContent.trim();
                    sizeguidTitle.textContent = anchorText + 's';
                }
            }

        }
    }

    // Initialize the selected values on page load and add change listeners
    document.querySelectorAll('.js.product-form-input').forEach(function (fieldset) {
        var optionNameElement = fieldset.querySelector('legend.label');
        if (!optionNameElement) return;
        var optionName = optionNameElement.innerText.trim().toLowerCase();

        var selectedOption = fieldset.querySelector('.option-btn:checked');
        var optionsCount = fieldset.querySelectorAll('.option-btn').length;
        if (selectedOption) {
            updateSelectedValue(optionName, selectedOption.value);
            // Don't call renderVariantUI here to preserve the "Select Size" state on load
            if (optionName.includes('size') && optionsCount === 1) {
                renderVariantUI(optionName, selectedOption);
            }
        }

        var options = fieldset.querySelectorAll('.option-btn');
        options.forEach(function (option) {
            option.addEventListener('change', function () {
                updateSelectedValue(optionName, option.value);
                renderVariantUI(optionName, option);
            });
        });
    });

    function renderVariantUI(optionName, input) {
        if (!input) return;

        var normalizedOptionName = optionName.toLowerCase();
        var isSizeOption = normalizedOptionName.includes('size');

        updateButtonText(input, isSizeOption);

        // If size is selected, update UI visibility
        if (isSizeOption) {
            var productAddCartForm = document.querySelector('.product-add-cart-form');
            var productSelectSize = document.querySelector('.product-select-size');
            var sizeSelectedValue = document.querySelector('#sizeSelectedValue');
            var stickyAddToCart = document.querySelector('#sticky-add-to-cart');
            var stickyAddToCartSize = document.querySelector('#sticky-add-to-cart-size');

            if (productAddCartForm) {
                productAddCartForm.style.display = 'block';
                productAddCartForm.style.zIndex = '1';
            }
            if (productSelectSize) {
                productSelectSize.style.display = 'none';
                productSelectSize.classList.add('select-size');
                productSelectSize.style.marginBottom = '75px';
            }
            if (sizeSelectedValue) {
                sizeSelectedValue.style.display = 'block';
            }
            if (stickyAddToCart) {
                stickyAddToCart.style.display = 'block';
            }
            if (stickyAddToCartSize) {
                stickyAddToCartSize.style.display = 'none';
            }
        }
    }

    function updateButtonText(input, forceSize) {
        var policy = input.getAttribute('data-inventory-policy');
        var submitBtn = document.querySelector('.product-form-submit');

        if (!submitBtn) return;

        var displayText = (policy === 'continue') ? 'Pre-order' : 'Add to bag';

        var btnSpan = submitBtn.querySelector('span');
        if (btnSpan) {
            btnSpan.textContent = displayText;
        } else {
            submitBtn.textContent = displayText;
        }
    }
    var triggerButtonsize = document.querySelector('.product-select-size');
    var sizetrigger = document.querySelector('.Size-wrapper legend');

    if (triggerButtonsize && sizetrigger) {
        triggerButtonsize.addEventListener('click', function () {
            sizetrigger.click();
        });
    }
}); 
